import React, { useState, useRef } from "react";
import Tooltip from "../Tooltip";
import "./style.scss";

const HotspotPoint = ({ id, x, y, title, image, mapWidth, mapHeight }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const hotspotRef = useRef(null);

  const positionStyle = {
    left: `${(x / 100) * mapWidth}px`,
    top: `${(y / 100) * mapHeight}px`,
  };

  const getTooltipPosition = () => {
    if (!hotspotRef.current) return null;

    const rect = hotspotRef.current.getBoundingClientRect();
    const position = {
      top: rect.top - 120,
      left: rect.left + rect.width / 2,
    };

    return position;
  };

  return (
    <div
      ref={hotspotRef}
      className="hotspot-point"
      style={positionStyle}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="hotspot-number">{id}</div>
      {showTooltip && (
        <Tooltip title={title} image={image} position={getTooltipPosition()} />
      )}
    </div>
  );
};

export default HotspotPoint;
